import Button from 'components/ui/Button';
import { FaStar } from 'react-icons/fa';
import styled from 'styled-components';
import { sidePadding } from 'styles/commonStyles';

const Container = styled.div`
  ${sidePadding};
  display: flex;
  align-items: center;
  height: 60px;
  border-top: 1px solid ${(props) => props.theme.global.borderColor};
  justify-content: space-between;
`;

const TextView = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const Circle = styled.div`
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 100%;
  background-color: ${(props) => props.theme.global.mainColor2};
  color: ${(props) => props.theme.global.whiteTextColor};
  font-size: 16px;
`;

const Grade = () => {
  return (
    <Container>
      <TextView>
        <Circle>
          <FaStar />
        </Circle>
        <span>무료</span>
      </TextView>
      <Button onClick={() => alert('준비중입니다.')}>Pro 업그레이드</Button>
    </Container>
  );
};

export default Grade;
